import { useNavigate } from 'react-router-dom';
import { McButton } from '@maersk-global/mds-react-wrapper';

import aliancaLogo from '../assets/alianca-logo-negativo.svg';
import useUserSessionContext from '../hooks/contexts/useUserSessionContext';

const LogoutPage = () => {
  const navigate = useNavigate();
  const { userSession } = useUserSessionContext();

  const title = userSession ? 'TMS Operations Hub' : 'Sessão encerrada!';

  const handleLogin = () => {
    navigate('/');
  };

  return (
    <div
      className="mds-flex mds-flex-column mds-secondary__background-color mds-secondary__on-background-color"
      style={{
        alignItems: 'center',
        height: '100vh',
        justifyContent: 'space-evenly',
        padding: '2rem',
      }}
    >
      <div
        className="mds-flex mds-flex-column mds-gap-500"
        style={{ alignItems: 'center' }}
      >
        <h3>{title}</h3>
        <McButton
          appearance="inverse"
          click={handleLogin}
          variant="plain"
          label="Voltar para a aplicação"
        ></McButton>
      </div>

      <img
        src={aliancaLogo}
        alt="Aliança - A Maersk Company"
        style={{ maxWidth: '100%', width: 'auto' }}
      />
    </div>
  );
};

export default LogoutPage;
